import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getClient } from 'redux/modules/teamManagement';
import { LeftNavLayout } from 'containers';
import { connect } from 'react-redux';
var OrgSettings = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    user: state.auth.user,
    orgBillingVisible: state.teamManagement.orgBillingVisible,
    organization: state.organization.current
  };
}, {
  getClient: getClient
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(OrgSettings, _Component);

  var _super = _createSuper(OrgSettings);

  function OrgSettings() {
    _classCallCheck(this, OrgSettings);

    return _super.apply(this, arguments);
  }

  _createClass(OrgSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getClient(this.props.organization.id);
    }
  }, {
    key: "render",
    value: function render() {
      var sidebarItems = [{
        link: "/org/".concat(this.props.organization.id, "/settings/social-accounts"),
        linkText: 'Social Accounts'
      }, {
        link: "/org/".concat(this.props.organization.id, "/settings/timezone"),
        linkText: 'Timezone'
      }, {
        link: "/org/".concat(this.props.organization.id, "/settings/users"),
        linkText: 'Users'
      }];

      if (this.props.orgBillingVisible) {
        sidebarItems.push({
          link: "/org/".concat(this.props.organization.id, "/settings/billing-history"),
          linkText: 'Billing History'
        });
      }

      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflow: 'auto',
        height: '100%'
      };
      var wrapStyle = {
        flex: '1 1 auto',
        padding: 0
      };
      var pageTitle = "".concat(this.props.organization.name).concat(this.props.organization.name.split('').pop() === 's' ? "'" : "'s", " Settings");
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: true,
        sidebarItems: sidebarItems,
        params: _objectSpread({}, this.props.params),
        wrapStyle: wrapStyle,
        appLayoutInnerStyle: appLayoutInnerStyle
      }, this.props.children);
    }
  }]);

  return OrgSettings;
}(Component)) || _class);
export { OrgSettings as default };